// Mock data for BE Bizz Europe microsite

export const stats = [
  { value: 17, suffix: '+', label: 'Years' },
  { value: 100, suffix: '+', label: 'Projects' },
  { value: 6, suffix: '', label: 'Major Centres' }
];

export const clients = [
  'OC MAX',
  'Bory Mall',
  'Petržalská Tržnica',
  'Shopping Palace',
  'Novum Prešov',
  'SC Hron'
];

export const services = [
  {
    id: 1,
    title: 'Strategy & Insights',
    outcome: 'Clarity + direction',
    icon: 'Compass',
    bullets: [
      'Market research',
      'Data analysis',
      'Positioning',
      'Marketing architecture',
      'Growth planning'
    ]
  },
  {
    id: 2,
    title: 'Brand & Design',
    outcome: 'Consistency + appeal',
    icon: 'Palette',
    bullets: [
      'Brand identity',
      'Creative direction',
      'UX/UI',
      'Visual communication',
      'Campaign design'
    ]
  },
  {
    id: 3,
    title: 'Content & Communication',
    outcome: 'Relevance + reach',
    icon: 'MessageSquare',
    bullets: [
      'Social media',
      'PR',
      'Influencers',
      'Content strategy',
      'E-mail marketing'
    ]
  },
  {
    id: 4,
    title: 'Media & Activation',
    outcome: 'Footfall + momentum',
    icon: 'Megaphone',
    bullets: [
      'Media planning',
      'Buying & production',
      'ATL / BTL',
      'Events',
      'On-site activations'
    ]
  },
  {
    id: 5,
    title: 'CRM & Performance',
    outcome: 'Retention + ROI',
    icon: 'BarChart3',
    bullets: [
      'Segmentation',
      'Automation',
      'Analytics',
      'Customer retention',
      'Reporting'
    ]
  }
];

export const processSteps = [
  {
    id: 1,
    title: 'Align',
    description: 'Goals + stakeholders + budget governance',
    icon: 'Target'
  },
  {
    id: 2,
    title: 'Plan',
    description: 'Yearly + quarterly + campaign architecture',
    icon: 'Calendar'
  },
  {
    id: 3,
    title: 'Execute',
    description: 'Daily coordination + production + suppliers',
    icon: 'Zap'
  },
  {
    id: 4,
    title: 'Measure',
    description: 'Reporting dashboards + insights + next actions',
    icon: 'TrendingUp'
  }
];

export const deliverables = [
  'Weekly action plan',
  'Monthly performance report',
  'Supplier coordination & negotiations',
  'Brand consistency across channels'
];

export const coreActivities = [
  'Stakeholder communication (management, tenants, legal, security)',
  'Campaign planning & execution',
  'Production management',
  'Budget control',
  'Reporting & performance analysis',
  'Materials & on-site updates'
];

export const weeklyRhythm = [
  { day: 'Mon', activity: 'Planning sync' },
  { day: 'Tue–Thu', activity: 'Production + activation' },
  { day: 'Fri', activity: 'KPI review + next week plan' }
];

export const caseStudies = [
  {
    id: 1,
    name: 'OC MAX',
    locations: 'Trnava, Trenčín, Nitra, Poprad',
    owner: 'Supernova Group',
    gla: 'Total 58,000 m²',
    shops: '200+',
    since: 'Since April 2017',
    tags: ['Daily marketing', 'Full service'],
    whatWeDid: 'Full in-house marketing, strategy, creative, daily service',
    outcome: 'Consistent campaigns + strong tenant alignment',
    image: 'https://customer-assets.emergentagent.com/job_619b4d5e-f51b-467f-ae93-a95fb1e339d8/artifacts/2ggadfei_Ref-OC_MAX_Trencin.jpg'
  },
  {
    id: 2,
    name: 'BORY MALL',
    owner: 'Penta Real Estate',
    gla: '54,000 m²',
    shops: '190',
    period: 'Jan 2014 – May 2015',
    tags: ['Grand opening', 'Daily marketing'],
    whatWeDid: 'Grand opening, strategy and daily marketing execution',
    outcome: 'Smooth launch execution across stakeholders',
    image: 'https://customer-assets.emergentagent.com/job_619b4d5e-f51b-467f-ae93-a95fb1e339d8/artifacts/hdxfeslj_Ref-Bory_mall.jpg'
  },
  {
    id: 3,
    name: 'PETRŽALSKÁ TRŽNICA',
    owner: 'Terno + Sandberg',
    gla: '5,000 m²',
    shops: '12',
    period: 'Jan 2020 – May 2021',
    tags: ['Strategy', 'Daily marketing'],
    whatWeDid: 'Strategy, plan realization, creative, advertising + digital',
    outcome: 'Clear identity + improved communication cadence',
    image: 'https://customer-assets.emergentagent.com/job_619b4d5e-f51b-467f-ae93-a95fb1e339d8/artifacts/ri31j2m3_Ref-Petrzalska_Trznica.jpg'
  },
  {
    id: 4,
    name: 'SHOPPING PALACE',
    owner: 'Bank Austria Real Invest',
    gla: '23,000 m²',
    shops: '83',
    period: 'Jan 2013 – Dec 2015',
    tags: ['Daily marketing', 'Crisis'],
    whatWeDid: 'Strategy, brand positioning, daily marketing, crisis',
    outcome: 'Strong seasonal performance support',
    image: 'https://customer-assets.emergentagent.com/job_619b4d5e-f51b-467f-ae93-a95fb1e339d8/artifacts/efkufrt2_Ref-Shopping_palace.jpg'
  },
  {
    id: 5,
    name: 'NOVUM PREŠOV',
    owner: 'Gemo Holding',
    gla: '32,000 m²',
    shops: '120',
    period: 'May – July 2020',
    tags: ['Branding'],
    whatWeDid: 'Creation of a shopping center name and logo, branding',
    outcome: 'Reliable delivery + strong visual identity',
    image: 'https://customer-assets.emergentagent.com/job_619b4d5e-f51b-467f-ae93-a95fb1e339d8/artifacts/ctm7pq9q_Ref-Novum_Presov.jpg'
  },
  {
    id: 6,
    name: 'SC HRON',
    owner: 'IRE Hron Property Holding, a.s.',
    gla: '9,000 m²',
    shops: '26',
    period: 'Jun 2008 – Dec 2016',
    tags: ['Strategy', 'Branding', 'Crisis'],
    whatWeDid: 'Full in-house marketing, strategy, creative, daily service, local activation, tenant comms',
    outcome: 'Strong community connection',
    image: 'https://customer-assets.emergentagent.com/job_619b4d5e-f51b-467f-ae93-a95fb1e339d8/artifacts/6jtz6o6j_Ref-SC_Hron.jpeg'
  }
];

export const caseStudyFilters = [
  'All',
  'Openings',
  'Reopenings',
  'Refurbishments',
  'Daily Marketing',
  'Crisis'
];

export const lifecycleStages = [
  { id: 1, title: 'Grand openings', icon: 'PartyPopper' },
  { id: 2, title: 'Refurbishments', icon: 'Wrench' },
  { id: 3, title: 'Re-openings', icon: 'RotateCcw' },
  { id: 4, title: 'Crisis communication', icon: 'AlertTriangle' },
  { id: 5, title: 'Crisis management', icon: 'Shield' }
];

export const contactInfo = {
  email: 'hello@bizz-europe.com',
  phone: '+421 9XX XXX XXX'
};
